import React from "react";
import "./Sidebar.css";
import { Avatar, IconButton } from "@material-ui/core";
import SidebarChat from "./SidebarChat";
import { MoreVert, Chat, DonutLarge, SearchOutlined } from "@material-ui/icons";

const Sidebar = ({ rooms, lastmessage }) => {
  return (
    <div className="sidebar">
      <div className="sidebar__header">
        <Avatar src="https://randomuser.me/api/portraits/men/82.jpg" />
        <div className="sidebar__headerRight">
          <IconButton>
            <DonutLarge />
          </IconButton>
          <IconButton>
            <Chat />
          </IconButton>
          <IconButton>
            <MoreVert />
          </IconButton>
        </div>
      </div>

      <div className="sidebar__search">
        <div className="sidebar__searchContainer">
          <SearchOutlined />
          <input type="text" placeholder="Search or start new chat" />
        </div>
      </div>

      <div className="sidebar__chats">
        {rooms?.map((room) => {
          return (
            <SidebarChat
              roomName={room.roomName}
              _id={room._id}
              key={room._id}
              lastmessage={lastmessage}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;
